(function(){
  'use strict';

  function ready(callback){
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',callback,{once:true});
    else callback();
  }

  ready(function(){
    var root=document.querySelector('[data-sh-cart-page]');
    if(!root)return;
    var busy=false;
    var recommendationsMedia=window.matchMedia('(min-width: 1051px)');

    function positionRecommendations(){
      var recommendations=root.querySelector('[data-sh-cart-recommendations]');
      var itemsColumn=root.querySelector('.sh-cart__items-column');
      var mobileAnchor=root.querySelector('[data-sh-cart-recommendations-anchor]');
      if(!recommendations||!itemsColumn||!mobileAnchor)return;

      if(recommendationsMedia.matches){
        if(recommendations.parentNode!==itemsColumn)itemsColumn.appendChild(recommendations);
        recommendations.classList.add('is-desktop-inline');
      }else{
        if(recommendations.previousElementSibling!==mobileAnchor)mobileAnchor.insertAdjacentElement('afterend',recommendations);
        recommendations.classList.remove('is-desktop-inline');
      }
    }


    function lineData(node){
      var line=node&&node.closest?node.closest('[data-sh-cart-line]'):null;
      return line?{
        cart_line_key:line.dataset.key||'',
        variant_id:line.dataset.variantId||'',
        product_handle:line.dataset.productHandle||'',
        product_title:line.dataset.productTitle||''
      }:{};
    }

    function track(eventName,data){
      var detail=Object.assign({
        event:eventName,
        cart_surface:'full_cart',
        device_class:window.innerWidth<=760?'mobile':'desktop',
        market:root.dataset.countryCode||'',
        cart_item_count:Number(root.dataset.cartItemCount||0),
        cart_value_cents:Number(root.dataset.cartValue||0)
      },data||{});
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push(detail);
      if(typeof window.clarity==='function'){
        try{window.clarity('event',eventName);}catch(error){/* no-op */}
      }
    }

    function status(message,isError){
      var node=document.querySelector('[data-sh-cart-status]');
      if(!node)return;
      node.textContent=message||'';
      node.hidden=!message;
      node.style.background=isError?'#8f1d15':'#111';
      clearTimeout(status.timer);
      if(message)status.timer=setTimeout(function(){node.hidden=true;},3200);
    }

    function addWorkingDays(date,days){
      var d=new Date(date.getTime());
      var left=Math.max(0,Number(days)||0);
      while(left>0){
        d.setDate(d.getDate()+1);
        if(d.getDay()!==0&&d.getDay()!==6)left--;
      }
      return d;
    }

    function renderArrival(){
      if(!root)return;
      var nodes=root.querySelectorAll('[data-sh-cart-arrival]');
      if(!nodes.length)return;
      var today=new Date();
      var format={weekday:'short',day:'numeric',month:'short'};
      Array.prototype.forEach.call(nodes,function(node){
        var min=Number(node.dataset.dispatchMin||0)+Number(node.dataset.transitMin||0);
        var max=Number(node.dataset.dispatchMax||0)+Number(node.dataset.transitMax||0);
        if(!min||!max)return;
        try{
          var from=addWorkingDays(today,min).toLocaleDateString('en-GB',format);
          var to=addWorkingDays(today,max).toLocaleDateString('en-GB',format);
          node.textContent=(node.dataset.prefix||'Estimated arrival')+' '+from+' – '+to+(node.dataset.suffix||'');
        }catch(error){/* keep server copy */}
      });
    }

    function refreshSection(){
      var url=new URL(root.dataset.cartUrl||'/cart',window.location.origin);
      url.searchParams.set('section_id',root.dataset.sectionId);
      return fetch(url.toString(),{
        credentials:'same-origin',
        cache:'no-store',
        headers:{'X-Requested-With':'XMLHttpRequest'}
      }).then(function(response){
        if(!response.ok)throw new Error('Unable to refresh bag');
        return response.text();
      }).then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var replacement=doc.querySelector('[data-sh-cart-page]');
        if(!replacement)throw new Error('Bag markup unavailable');
        root.replaceWith(replacement);
        root=replacement;
        positionRecommendations();
        renderArrival();
        document.dispatchEvent(new CustomEvent('cart:build'));
        return fetch(root.dataset.cartJsonUrl||'/cart.js',{
          credentials:'same-origin',
          cache:'no-store',
          headers:{Accept:'application/json'}
        });
      }).then(function(response){
        return response.json();
      }).then(function(cart){
        document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:cart}}));
        return cart;
      });
    }

    function discountActive(cart,code){
      var wanted=String(code||'').trim().toLowerCase();
      if(!wanted||!cart)return false;
      if(Array.isArray(cart.discount_codes)&&cart.discount_codes.some(function(entry){
        return String(entry.code||'').trim().toLowerCase()===wanted&&entry.applicable!==false;
      }))return true;
      var applications=[];
      if(Array.isArray(cart.cart_level_discount_applications))applications=applications.concat(cart.cart_level_discount_applications);
      if(Array.isArray(cart.items))cart.items.forEach(function(item){
        if(Array.isArray(item.line_level_discount_allocations))item.line_level_discount_allocations.forEach(function(allocation){
          if(allocation.discount_application)applications.push(allocation.discount_application);
        });
      });
      return applications.some(function(entry){
        return String(entry.code||entry.title||'').trim().replace(/\s+applied$/i,'').toLowerCase()===wanted;
      });
    }

    function mutate(url,payload,message,successEvent,eventData){
      if(busy)return Promise.resolve();
      busy=true;
      root.classList.add('is-updating');
      return fetch(url,{
        method:'POST',
        credentials:'same-origin',
        headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest','Accept':'application/json'},
        body:JSON.stringify(payload)
      }).then(function(response){
        return response.json().then(function(data){
          if(!response.ok)throw new Error(data.description||data.message||'Unable to update bag');
          return data;
        });
      }).then(function(){
        return refreshSection();
      }).then(function(cart){
        if(message)status(message,false);
        if(successEvent)track(successEvent,Object.assign({updated_cart_item_count:Number(cart.item_count||0),updated_cart_value_cents:Number(cart.total_price||0)},eventData||{}));
        return cart;
      }).catch(function(error){
        status(error.message||'Unable to update bag.',true);
        track('cart_update_error',Object.assign({error_message:error.message||'Unable to update bag.'},eventData||{}));
      }).finally(function(){
        busy=false;
        if(root)root.classList.remove('is-updating');
      });
    }

    function openSupport(){
      track('cart_live_chat_open');
      if(window.__shPerformanceGate&&typeof window.__shPerformanceGate.openCommslayer==='function'){
        window.__shPerformanceGate.openCommslayer();
        return;
      }
      if(window.$chatwoot&&typeof window.$chatwoot.toggle==='function'){
        window.$chatwoot.toggle('open');
        return;
      }
      var launcher=document.getElementById('SickHausChatLauncher');
      if(launcher){launcher.click();return;}
      var bubble=document.querySelector('.woot-widget-bubble,button.woot-widget-bubble,[data-chat-widget-button]');
      if(bubble){bubble.click();return;}
      status('Live chat is loading. Please try again in a moment.',false);
    }

    document.addEventListener('change',function(event){
      var select=event.target.closest('[data-sh-cart-quantity]');
      if(!select||!root.contains(select))return;
      var line=select.closest('[data-sh-cart-line]');
      if(!line)return;
      var quantity=Math.min(99,Math.max(1,parseInt(select.value,10)||1));
      if(String(quantity)!==String(select.value))select.value=quantity;
      var data=Object.assign(lineData(select),{quantity:quantity});
      track('cart_quantity_change',data);
      mutate(root.dataset.cartChangeUrl||'/cart/change.js',{id:line.dataset.key,quantity:quantity},'Bag updated.','cart_quantity_updated',data);
    });

    document.addEventListener('click',function(event){
      var step=event.target.closest('[data-sh-cart-step]');
      if(step&&root.contains(step)){
        event.preventDefault();
        if(busy)return;
        var stepper=step.closest('[data-sh-cart-stepper]');
        var stepInput=stepper?stepper.querySelector('[data-sh-cart-quantity]'):null;
        if(!stepInput)return;
        var current=parseInt(stepInput.value,10)||1;
        var next=Math.min(99,Math.max(1,current+Number(step.dataset.shCartStep||0)));
        if(next===current)return;
        stepInput.value=next;
        stepInput.dispatchEvent(new Event('change',{bubbles:true}));
        return;
      }

      var continueLink=event.target.closest('[data-sh-cart-continue]');
      if(continueLink&&root.contains(continueLink)){
        track('cart_continue_shopping');
        return;
      }

      var edit=event.target.closest('[data-sh-cart-edit]');
      if(edit&&root.contains(edit)){
        track('cart_item_edit',lineData(edit));
        return;
      }

      var remove=event.target.closest('[data-sh-cart-remove]');
      if(remove&&root.contains(remove)){
        event.preventDefault();
        var line=remove.closest('[data-sh-cart-line]');
        if(line){
          var removeData=lineData(remove);
          track('cart_item_remove',removeData);
          mutate(root.dataset.cartChangeUrl||'/cart/change.js',{id:line.dataset.key,quantity:0},'Item removed.','cart_item_removed',removeData);
        }
        return;
      }

      var promoSummary=event.target.closest('.sh-cart__promo summary');
      if(promoSummary&&root.contains(promoSummary)){
        var details=promoSummary.closest('details');
        window.setTimeout(function(){track('cart_promo_toggle',{state:details&&details.open?'open':'closed'});},0);
        return;
      }

      var apply=event.target.closest('[data-sh-cart-discount-apply]');
      if(apply&&root.contains(apply)){
        event.preventDefault();
        var input=root.querySelector('[data-sh-cart-discount-input]');
        var code=input?input.value.trim():'';
        var message=root.querySelector('[data-sh-cart-discount-status]');
        if(!code){
          if(message){message.textContent='Enter a code first.';message.classList.add('is-error');}
          if(input)input.focus();
          return;
        }
        if(busy)return;
        track('cart_discount_submit',{discount_code:code.toUpperCase()});
        busy=true;
        root.classList.add('is-updating');
        apply.disabled=true;
        apply.textContent='Applying…';
        fetch(root.dataset.cartUpdateUrl||'/cart/update.js',{
          method:'POST',
          credentials:'same-origin',
          headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest','Accept':'application/json'},
          body:JSON.stringify({discount:code})
        }).then(function(response){
          return response.json().then(function(data){
            if(!response.ok)throw new Error(data.description||data.message||'Unable to apply code');
            return data;
          });
        }).then(function(){
          return refreshSection();
        }).then(function(cart){
          if(discountActive(cart,code)){
            status(code.toUpperCase()+' applied.',false);
            track('cart_discount_applied',{discount_code:code.toUpperCase()});
          }else{
            status('That code is invalid or is not eligible for this bag.',true);
            track('cart_discount_rejected',{discount_code:code.toUpperCase()});
          }
        }).catch(function(error){
          status(error.message||'Unable to apply that code.',true);
          track('cart_discount_error',{discount_code:code.toUpperCase(),error_message:error.message||''});
        }).finally(function(){
          busy=false;
          if(root)root.classList.remove('is-updating');
        });
        return;
      }

      var support=event.target.closest('[data-sh-cart-support]');
      if(support&&root.contains(support)){
        event.preventDefault();
        openSupport();
        return;
      }

      var express=event.target.closest('[data-sh-cart-express]');
      if(express&&root.contains(express))track('cart_express_checkout_click');
    });

    document.addEventListener('keydown',function(event){
      if(event.key!=='Enter')return;
      var quantityInput=event.target.closest('[data-sh-cart-quantity]');
      if(quantityInput&&root.contains(quantityInput)){
        event.preventDefault();
        quantityInput.blur();
        return;
      }
      var input=event.target.closest('[data-sh-cart-discount-input]');
      if(!input||!root.contains(input))return;
      event.preventDefault();
      var apply=root.querySelector('[data-sh-cart-discount-apply]');
      if(apply)apply.click();
    });

    document.addEventListener('submit',function(event){
      var form=event.target.closest('[data-sh-cart-form]');
      if(!form||!root.contains(form))return;
      var checkout=event.submitter&&event.submitter.matches('[data-sh-cart-checkout]')?event.submitter:root.querySelector('[data-sh-cart-checkout]');
      if(!checkout)return;
      var termsRequired=checkout.dataset.termsRequired==='true';
      var terms=root.querySelector('[data-sh-cart-terms]');
      if(termsRequired&&terms&&!terms.checked){
        event.preventDefault();
        status('Please accept the terms before checkout.',true);
        terms.focus();
        return;
      }
      track('cart_checkout_click',{checkout_type:'standard'});
      checkout.classList.add('is-loading');
      checkout.textContent='Opening checkout…';
    });

    positionRecommendations();
    renderArrival();
    if(typeof recommendationsMedia.addEventListener==='function')recommendationsMedia.addEventListener('change',positionRecommendations);
    else if(typeof recommendationsMedia.addListener==='function')recommendationsMedia.addListener(positionRecommendations);

    track('cart_page_view',{
      notice_type:root.dataset.lowStock==='true'?'low_stock':'saved',
      delivery_term:(root.dataset.deliveryTerm||'Delivery').toLowerCase()
    });
  });
})();
